export enum LoanFormName {
    Annuïtair = 'Annuïtair',
}

export enum LoanForm {
    Aflossingsvrij = '52',
    Lineair = '55',
    Annuïtair = '58',
    Leven = '61',
    Spaar = '64',
    Banksparen = '67',
    Beleggings = '76',
    Hybride = '79',
}

export const loanFormReadable = (loanForm: LoanForm): string => {
    const loanForms: string[] = [];
    loanForms[52] = 'Aflossingsvrij';
    loanForms[55] = 'Lineair';
    loanForms[58] = 'Annuïtair';
    loanForms[61] = 'Leven';
    loanForms[64] = 'Spaar';
    loanForms[67] = 'Banksparen';
    loanForms[76] = 'Beleggings';
    loanForms[79] = 'Hybride';
    return loanForms[parseInt(loanForm)];
};
